import React, { type ReactNode, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { type IStatusFormatterProps, StatusFormatter } from "./StatusFormatter";
import { Tooltip } from "src/shared/formatters/Tooltip";

export interface IBooleanStatusFormatterProps {
  children: boolean;
  showsText?: boolean;
  showsTooltip?: boolean;
  activeText?: ReactNode;
  inactiveText?: ReactNode;
}

export const BooleanStatusFormatter = ({
  children,
  showsText = true,
  showsTooltip = !showsText,
  activeText = <FormattedMessage id="status.active" />,
  inactiveText = <FormattedMessage id="status.inactive" />,
}: IBooleanStatusFormatterProps) => {
  const { text, status } = useMemo<{
    text: ReactNode;
    status: IStatusFormatterProps["status"];
  }>(() => {
    if (children) {
      return { text: activeText, status: "active" };
    } else {
      return { text: inactiveText, status: "inactive" };
    }
  }, [activeText, children, inactiveText]);
  return (
    <Tooltip isOpen={showsTooltip} tooltipRender={text}>
      <StatusFormatter status={status}>{showsText && text}</StatusFormatter>
    </Tooltip>
  );
};

/**
 * @deprecated
 */
export default BooleanStatusFormatter;
